import React, { useState, useEffect } from "react";

const Timer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        D: Math.floor(difference / (1000 * 60 * 60 * 24)),
        H: Math.floor((difference / (1000 * 60 * 60)) % 24),
        M: Math.floor((difference / 1000 / 60) % 60),
        S: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <div key={interval} className="bg-black">
        <span className="mx-1">{timeLeft[interval]}</span>
        <span className="mx-1">{interval}</span>
      </div>
    );
  });

  return (
    <div className="d-flex flex-wrap justify-content-around align-items-center">
      {timerComponents.length ?
        <>
          {timerComponents}&nbsp;<img src="https://fonts.gstatic.com/s/e/notoemoji/latest/23f0/512.gif" alt=":alarm_clock:" width="32" height="32" />
        </> : <span>Time's up ! &nbsp;<img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f975/512.gif" alt=":hot_face:" width="40" height="40"></img> </span>}
    </div>
  );
};

export default Timer;
